import DTChangeShippingDateThenSendMacroNode from '../NodeGroups/DTCopyTextSendMacro/DTChangeShippingDateThenSendMacroNode/DTChangeShippingDateThenSendMacroNode';
import { getShowConfirmationPage } from '../../../selectors/tools';
import { useSelector } from 'react-redux';

const ChangeShippingDateThenSendMacro = () => {
  const showConfirmationPage = useSelector(getShowConfirmationPage);

  return (
    <DTChangeShippingDateThenSendMacroNode
      showConfirmation={showConfirmationPage}
      message={'The order shipping date has been changed.'}
    />
  );
};

export default ChangeShippingDateThenSendMacro;
